import React, { memo } from 'react';
import { makeStyles } from '@material-ui/styles';
import { CDN_URL } from 'settings';

const useStyles = makeStyles({
  ImgContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '1.5rem',

    '& img': {
      maxWidth: '2.5rem'
    },

    '& span': {
      fontWeight: 400,
      fontSize: '1.5rem',
      color: '#242424',
      marginLeft: '0.5rem'
    }
  }
});

const Logo = () => {
  const classes = useStyles();
  return (
    <div className={classes.ImgContainer}>
      <img src={`${CDN_URL}/topbar/sun.svg`} alt="Logo checkout sun" />
      <span>Checkout Sun</span>
    </div>
  );
};

export default memo(Logo);
